/**
 * Old Drive "Shared" destination removed (Aiden).
 * Remap stored notification links that still point at /drive/shares.
 */
export function resolveNotificationAction(
  action?: string | null,
): string | undefined {
  if (!action) return undefined;

  try {
    const path = action.includes('://')
      ? new URL(action).pathname + new URL(action).search
      : action;
    if (path === '/drive/shares' || path.endsWith('/drive/shares')) {
      return '/drive?shared=1';
    }
  } catch {
    if (action.includes('/drive/shares')) {
      return '/drive?shared=1';
    }
  }

  return action;
}
